export const baseUrl = "https://crm.propcasa.com/api/auth/user/";
// export const baseUrl = "http://localhost:8000/api/auth/user/";
